<template>
  <div class="content">
    <img src="@/assets/images/list/ang1.png" class="ang1">
    <img src="@/assets/images/list/ang2.png" class="ang2">
    <img src="@/assets/images/list/ang3.png" class="ang3">
    <img src="@/assets/images/list/ang4.png" class="ang4">
    <div class="videoTitle">
      <img src="@/assets/images/accident/video3.png" class="video2">
      <span>{{title}}</span>
      <img src="@/assets/images/accident/video2.png" class="video3">
    </div>
    <slot/>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type: String,
      default:()=>'视频通话记录'
    }
  }

}
</script>

<style lang="scss">
  .content {
    position: relative;
    background: rgba(15, 31, 70, 0.6);
    box-shadow: 0px 0px 12px 0px rgba(0, 159, 255, 0.54);
    border: 1px solid #0278C6;
    margin: 2px;
    .ang1 {
      position: absolute;
      top: -3px;
      left: -3px;
    }
    .ang2 {
      position: absolute;
      top: -3px;
      right: -3px;
    }
    .ang3 {
      position: absolute;
      bottom: -3px;
      left: -3px;
    }
    .ang4 {
      position: absolute;
      bottom: -3px;
      right: -3px;
    }
    .videoTitle {
      position: absolute;
      top: -15px;
      left: 0;
      right: 0;
      margin: auto;
      width: 210px;
      height: 30px;
      background: url("../../../assets/images/accident/video1.png") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      z-index: 99;
      span {
        color: #17ECFE;
        line-height: 30px;
        font-size: 18px;
        font-weight: 500;
        margin: 0 10px;
      }
    }
  }
</style>